import instance from 'utils/apiCalls';
import { LOG_URLS } from './logUrls';
import { paramsI } from '../../../types/interface';

export const getAdminLogs = (params: paramsI) => async () => {
  const response = await instance.get(LOG_URLS.GET_ADMIN_LOGS, { params });
  return response;
};

export const getLogByUserId = (userId: number, params: paramsI) => async () => {
  const response = await instance.get(
    `${LOG_URLS.GET_LOG_BY_USER_ID}/${userId}`,
    {
      params: params
    }
  );
  return response;
};

export const getLogByRoleId = (roleId: number, params: paramsI) => async () => {
  const response = await instance.get(
    `${LOG_URLS.GET_LOG_BY_ROLE_ID}/${roleId}`,
    {
      params: params
    }
  );
  return response;
};

export const getLogByProductId =
  (productId: number, params: paramsI) => async () => {
    const response = await instance.get(
      `${LOG_URLS.GET_LOG_BY_PRODUCT_ID}/${productId}`,
      {
        params: params
      }
    );
    return response;
  };

export const getLogByWithIncomeConfigureId =
  (withIncomeConfigureId: number, params: paramsI) => async () => {
    const response = await instance.get(
      `${LOG_URLS.GET_LOG_BY_WITH_INCOME_CONFIGURE_ID}/${withIncomeConfigureId}`,
      {
        params: params
      }
    );
    return response;
  };

export const getLogByWithOutcomeConfigureId =
  (withOutcomeConfigureId: number, params: paramsI) => async () => {
    const response = await instance.get(
      `${LOG_URLS.GET_LOG_BY_WITHOUT_INCOME_CONFIGURE_ID}/${withOutcomeConfigureId}`,
      {
        params: params
      }
    );
    return response;
  };

export const getLogByAdminLevelId =
  (adminLevelId: number, params: paramsI) => async () => {
    const response = await instance.get(
      `${LOG_URLS.GET_LOG_BY_ADMIN_LEVEL_ID}/${adminLevelId}`,
      {
        params: params
      }
    );
    return response;
  };
